export default __webpack_public_path__ + "static/media/slide_4.3c283b29.webp";